var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showIP)?_c('div',_vm._l((_vm.ips),function(ref){
var ip = ref.ip;
var name = ref.name;
return _c('span',{key:ip},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(name),expression:"name"}]},[_vm._v(_vm._s(ip))]),_vm._v(" "),_c('CopyToClipboard',{staticClass:"icon-btn",attrs:{"text":ip,"label-as":"tooltip","action-color":"bg-transparent"}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }